import { API_ENDPOINTS } from "../config/api/apiCall";
import { callApi } from "../utils/apiClient";

export const loadStoreLedgerList = async(payload)=>{
    try {       
//lakshmi changes done on 09012026-Reason Store ledger list  with Stock Age Calculation
        //return await callApi(API_ENDPOINTS.STORE_LEDGER_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);
        return await callApi(API_ENDPOINTS.STORE_LEDGER_GET_LIST_STOCK_AGE, 'POST', { 'Content-Type': 'application/json' }, payload);


    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
}

export const loadStoreLedgerTranscationList = async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.STORE_LEDGER_TRANSACTION_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading ledger transaction", error);
        throw error;
    }
}